import React, { useState, useEffect } from 'react';
import regeneratorRuntime from 'regenerator-runtime';

export default function SuggestionsDropdown( props ) {
    const [suggestions, setSuggestions] = useState([])

    async function getSuggestionsFromAPI( query ) {
        let args = `?args[s]=${query}&args[per_page]=5`;
        let result = await fetch(`/wp-json/wp-elasticsearch/autocomplete${args}`)
        let data = await result.json()

        setSuggestions( data.records )
    }

    useEffect(() => {
        let query = encodeURIComponent( props.searchQuery )

        if ( query.length < 3 ) {
            return
        }

        getSuggestionsFromAPI( query )
    }, [ props.searchQuery ] )

    if ( suggestions.length ) {
        return (
            <datalist id="wpes-datalist" className="search-suggestions">
                {suggestions.map( suggestion => {
                    return (
                        <option 
                            value={ suggestion._source.title } 
                            key={ suggestion._id }
                            >{ suggestion._source.type }</option
                        >
                    )
                })}
            </datalist>
        )
    } else {
        return ''
    }
}